var _path, _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03948 5.58118C4.28013 5.58118 3.66455 6.19676 3.66455 6.95611V16.4998C3.66455 17.2591 4.28013 17.8747 5.03948 17.8747H9.48763V21.0163C9.48763 21.687 10.3263 21.9906 10.7557 21.4754L12.0488 19.9236L13.6298 18.0265C13.67 17.9781 13.7026 17.9272 13.7279 17.8747H19.7054C20.4648 17.8747 21.0804 17.2591 21.0804 16.4998V6.95611C21.0804 6.19676 20.4648 5.58118 19.7054 5.58118H5.03948Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.59153,
    cy: 11.6538,
    r: 1.26036,
    fill: "#8DB853"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3725,
    cy: 11.6538,
    r: 1.26036,
    fill: "#8DB853"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1537,
    cy: 11.6538,
    r: 1.26036,
    fill: "#8DB853"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalk);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCAyNiAyNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjAzOTQ4IDUuNTgxMThDNC4yODAxMyA1LjU4MTE4IDMuNjY0NTUgNi4xOTY3NiAzLjY2NDU1IDYuOTU2MTFWMTYuNDk5OEMzLjY2NDU1IDE3LjI1OTEgNC4yODAxMyAxNy44NzQ3IDUuMDM5NDggMTcuODc0N0g5LjQ4NzYzVjIxLjAxNjNDOS40ODc2MyAyMS42ODcgMTAuMzI2MyAyMS45OTA2IDEwLjc1NTcgMjEuNDc1NEwxMi4wNDg4IDE5LjkyMzZMMTMuNjI5OCAxOC4wMjY1QzEzLjY3IDE3Ljk3ODEgMTMuNzAyNiAxNy45MjcyIDEzLjcyNzkgMTcuODc0N0gxOS43MDU0QzIwLjQ2NDggMTcuODc0NyAyMS4wODA0IDE3LjI1OTEgMjEuMDgwNCAxNi40OTk4VjYuOTU2MTFDMjEuMDgwNCA2LjE5Njc2IDIwLjQ2NDggNS41ODExOCAxOS43MDU0IDUuNTgxMThINS4wMzk0OFoiIGZpbGw9IndoaXRlIi8+CjxjaXJjbGUgY3g9IjguNTkxNTMiIGN5PSIxMS42NTM4IiByPSIxLjI2MDM2IiBmaWxsPSIjOERCODUzIi8+CjxjaXJjbGUgY3g9IjEyLjM3MjUiIGN5PSIxMS42NTM4IiByPSIxLjI2MDM2IiBmaWxsPSIjOERCODUzIi8+CjxjaXJjbGUgY3g9IjE2LjE1MzciIGN5PSIxMS42NTM4IiByPSIxLjI2MDM2IiBmaWxsPSIjOERCODUzIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };